<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

  <v-layout
    justify-left
    wrap>
    <v-flex md12>
      <h3 class="heading-4 mb-0">{{ 'krita.faktoring'| translate }} - {{ factoringId }} ({{ factoringStatus }}) </h3>
    </v-flex>


    <v-flex md4>
      <div class="v-card v-sheet theme--light">
        <div class="v-card__title v-card__title--primary">
          <h3 class="heading-4 mb-0">{{ 'krita.factoring.generalinfo' | translate }}</h3>
        </div>
        <div class="v-card__text">
          <hr>
          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.id'| translate }} ({{ 'krita.status'| translate }})</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoringId }} ({{ factoringStatus }})</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.applicationid'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right"><router-link 
                :to="{name: 'Application detail', params: {id: factoring.ApplicationId}}" 
                target="_self">{{ factoring.ApplicationId }}</router-link></v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.claimantname'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ claimant.Name }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.claimantregistryid'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ claimant.RegistryId | kennitala }}</v-flex>
          </v-layout>


          <!--          <v-layout row>-->
          <!--            <v-flex md6>{{ 'krita.factoring.created'| translate }}</v-flex>-->
          <!--            <v-flex-->
          <!--              md6-->
          <!--              class="text-md-right">{{ factoring.Created | date }}</v-flex>-->
          <!--          </v-layout>-->

        </div>
      </div>
    </v-flex>



    <v-flex md4>
      <div class="v-card v-sheet theme--light">
        <div class="v-card__title v-card__title--primary">
          <h3 class="heading-4 mb-0">{{ 'krita.factoring.otherInfo' | translate }}</h3>
        </div>
        <div class="v-card__text">
          <hr>
          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.offerdate'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoring.OfferDate | date }}</v-flex>
          </v-layout>

          <v-layout 
            v-if="factoring.RepaymentDate !== null" 
            row>
            <v-flex md6>{{ 'krita.factoring.repaymentdate'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoring.RepaymentDate | date }}</v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.facduedate'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoring.FactoringDueDate | date }}</v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.duration'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoringExt.duration }}</v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6>
              {{ 'krita.factoring.originalcapital' | translate }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on"><v-icon>info</v-icon></span>
                </template>
                <span>{{ 'krita.factoring.underlyingamount' | translate }}</span>
              </v-tooltip>
            </v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoring.Amount | amount }}</v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.bufferAmount'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoringExt.bufferAmount | amount }}</v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6>
              {{ 'krita.factoring.feeamount' | translate }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on"><v-icon>info</v-icon></span>
                </template>
                <span>{{ 'krita.factoring.feehelp' | translate }}</span>
              </v-tooltip>
            </v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoring.Fee | amount }}</v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6>
              {{ 'krita.factoring.initialamount' | translate }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on"><v-icon>info</v-icon></span>
                </template>
                <span>{{ 'krita.factoring.initamounthelp' | translate }}</span>
              </v-tooltip>
            </v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoring.InitialTransferAmount | amount }}</v-flex>
          </v-layout>

        </div>
      </div>
    </v-flex>



    <v-flex md4>
      <div class="v-card v-sheet theme--light">
        <div class="v-card__title v-card__title--primary">
          <h3 class="heading-4 mb-0">{{ 'krita.factoring.amountsonfac' | translate }}</h3>
          <!--<v-img-->
          <!--:src="logo"-->
          <!--contain-->
          <!--height="50"-->
          <!--/>-->
        </div>
        <div class="v-card__text">
          <hr>

          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.unpaidCapital'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoringExt.unpaidCapital | amount }}</v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6>{{ 'krita.factoring.unpaidFee'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoringExt.unpaidFee | amount }}</v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6>
              {{ 'krita.factoring.penaltyinterest' | translate }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on"><v-icon>info</v-icon></span>
                </template>
                <span>{{ 'krita.factoring.penaltyinteresthelp' | translate }}</span>
              </v-tooltip>
            </v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoring.CurrentPenaltyInterest | amount }}</v-flex>
          </v-layout>


          <hr>
          <v-layout row>
            <v-flex md6>
              {{ 'krita.factoring.remainingamount' | translate }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on"><v-icon>info</v-icon></span>
                </template>
                <span>{{ 'krita.factoring.remainingamounthelp' | translate }}</span>
              </v-tooltip>
            </v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoring.RemainigAmount | amount }}</v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6>
              {{ 'krita.factoring.alreadypaid' | translate }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on"><v-icon>info</v-icon></span>
                </template>
                <span>{{ 'krita.factoring.alreadypaidhelp' | translate }}</span>
              </v-tooltip>
            </v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoring.AlreadyPaidAmount | amount }}</v-flex>
          </v-layout>

          <v-layout row>
            <v-flex md6>
              {{ 'krita.factoring.currentbuffer' | translate }}
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on"><v-icon>info</v-icon></span>
                </template>
                <span>{{ 'krita.factoring.currentbufferhelp' | translate }}</span>
              </v-tooltip>
            </v-flex>
            <v-flex
              md6
              class="text-md-right">{{ factoring.CurrentBuffer | amount }}</v-flex>
          </v-layout>

        </div>
      </div>
    </v-flex>
  </v-layout>
</template>



<script>
  import EnumIterator from '../helper/EnumIterator';
  export default {
    name: 'FactoringDetailInfo',
    props: ['factoringId','factoring','bankClaim','claimant','factoringExt'],
    data: () => ({
      logo: require('../../assets/scandia-logo.png'),
    }),
    computed:
    {
      factoringStatus ()
      {
        let self = this;
        return self.$t(EnumIterator.processFactoringStatus(self.factoring.Status));
      },

    },
  }
</script>

<style lang="css" scoped>


</style>
